package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonElement

@Serializable
data class UsageAdoptionSummary(
    @SerialName("total_users") val totalUsers: Int = 0,
    @SerialName("active_users") val activeUsers: Int = 0,
    @SerialName("adoption_rate") val adoptionRate: Double? = null,
    @SerialName("never_logged_in") val neverLoggedIn: Int = 0,
    @SerialName("matching_records_count") val matchingRecordsCount: Int = 0,
    @SerialName("matching_records_label") val matchingRecordsLabel: String = ""
)

@Serializable
data class UsageAdoptionRow(
    val role: String = "",
    @SerialName("total_users") val totalUsers: Int = 0,
    @SerialName("active_users") val activeUsers: Int = 0,
    @SerialName("adopted_users") val adoptedUsers: Int = 0,
    @SerialName("adoption_rate") val adoptionRate: Double? = null,
    @SerialName("average_logins_per_user") val averageLoginsPerUser: Double = 0.0,
    @SerialName("never_logged_in") val neverLoggedIn: Int = 0
)

@Serializable
data class UsageAdoptionReportResponse(
    val summary: UsageAdoptionSummary,
    val rows: List<UsageAdoptionRow> = emptyList(),
    val pagination: JsonElement? = null
)

@Serializable
data class UsageAdoptionPagination(
    val total: Int? = null,
    @SerialName("total_count") val totalCount: Int? = null,
    val count: Int? = null,
    val limit: Int? = null,
    val offset: Int? = null,
    val page: Int? = null,
    @SerialName("page_size") val pageSize: Int? = null
)

@Serializable
data class PerformanceCategoryResponse(
    val id: String? = null,
    @SerialName("category_name") val categoryName: String? = null,
    @SerialName("min_percentage") val minPercentage: Double? = null,
    @SerialName("max_percentage") val maxPercentage: Double? = null,
    @SerialName("display_order") val displayOrder: Int? = null
)
